import React, { lazy, Suspense, useMemo } from 'react';
import useGameProvidersController from '../../../../hooks/site/game/providers/useGameProvidersController';
import Grid from '@mui/material/Grid2';
import CategoriesGames from './categories/CategoriesGames';
import { Box, Stack } from '@mui/material';
import ErrorBoundary from '../../../../components/material-ui/error_boundary/ErrorBoundary';
import AllGames from './games/AllGames';
import CollectionsList from './collections/CollectionsList';

const SelectedGame = lazy(() => import('./games/SelectedGame'));
const CategoriesList = lazy(() => import('./categories/CategoriesList'));

export default function GameProviderContent() {
  const {
    selectCollectionId,
    selectCategoryId,
    categories,
    categoryName,
    tableContainerRef,
    currentCollectionRef,
    setSelectCategoryId,
    deleteCategories,
    setSelectCollectionId,
    editCollection,
    addCollection,
    deleteCollection,
    saveCategory,
    updateCategoryGames,
    updateCasinos,
    getCollectionInfo,
    updateGameInfo
  } = useGameProvidersController();

  const sizeCollection = { xs: 12, md: 4 };
  const sizeBigBlog = { xs: 12, md: 8 };

  return (
    <Grid container spacing={1}>
      <Grid size={sizeCollection}>
        <Stack gap={1} sx={{ paddingRight: { xs: 0, sm: 2 } }} minHeight={`calc(100svh - 90px)`}>
          <ErrorBoundary>
            <CollectionsList
              selectCollectionId={selectCollectionId}
              addCollection={addCollection}
              editCollection={editCollection}
              deleteCollection={deleteCollection}
              setSelectCollectionId={setSelectCollectionId}
              updateCasinos={updateCasinos}
              getCollectionInfo={getCollectionInfo}
              tableContainerRef={tableContainerRef}
              currentCollectionRef={currentCollectionRef}
            />
          </ErrorBoundary>
          <ErrorBoundary>
            <Suspense>
              <CategoriesList
                selectCollectionId={selectCollectionId}
                selectCategoryId={selectCategoryId}
                categories={categories}
                setSelectCategoryId={setSelectCategoryId}
                deleteCategories={deleteCategories}
                saveCategory={saveCategory}
              />
            </Suspense>
          </ErrorBoundary>
        </Stack>
      </Grid>
      <Grid container size={sizeBigBlog} spacing={1}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <ErrorBoundary>
            <CategoriesGames
              selectCategoryId={selectCategoryId}
              categories={categories}
              categoryName={categoryName}
            />
          </ErrorBoundary>
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <ErrorBoundary>
            <AllGames
              selectCategoryId={selectCategoryId}
              categoryName={categoryName}
              updateCategoryGames={updateCategoryGames}
            />
          </ErrorBoundary>
        </Grid>
        <Grid size={12} mt={'auto'}>
          <ErrorBoundary>
            <Suspense>
              <SelectedGame
                categoryName={categoryName}
                updateGameInfo={updateGameInfo}
                collectionId={selectCollectionId}
                selectCategoryId={selectCategoryId}
              />
            </Suspense>
          </ErrorBoundary>
        </Grid>
      </Grid>
    </Grid>
  );
}
